import { Check } from "lucide-react";
import { SectionHead } from "@/components/site/SectionHead";
import { Reveal } from "@/components/site/Reveal";

const groups = [
  {
    part: "Posts — 201",
    items: [
      <span key="1"><b>Square tubing</b></span>,
      <span key="2"><b>Round tubing</b> — the center hole cluster gives fastening points as a round face curves away</span>,
      <span key="3"><b>New builds or existing posts</b></span>,
    ],
  },
  {
    part: "Rails — 202",
    items: [
      <span key="1"><b>Square tubing</b></span>,
      <span key="2"><b>Rectangular tubing</b></span>,
      <span key="3"><b>Cee purlin</b></span>,
    ],
  },
];

export const Compatibility = () => (
  <section className="section" data-testid="compatibility-section">
    <div className="wrap">
      <SectionHead num="04" eyebrow="Compatibility" title="What it goes on, what it holds." />
      <div className="fits">
        {groups.map((g, i) => (
          <Reveal key={g.part} delay={i * 0.12}>
            <div className="card" data-testid={`compat-card-${i + 1}`}>
              <div className="fit-part">{g.part}</div>
              <ul className="fit-list">
                {g.items.map((it, j) => (
                  <li key={j}>
                    <Check size={17} aria-hidden="true" />
                    {it}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
